import WishlistsSocialShareChannelsSchema from "@apps/wishlist/schemas/WishlistsSocialShareChannelsSchema";
import { array, boolean, object } from "superstruct";

export const GiftRegistryStorefrontValuesSettingsSchema = object({
    isRegistrantAddressRequired: boolean(),
    shareChannelTypes: array(WishlistsSocialShareChannelsSchema),
});
